import _ from 'underscore';
import React, { useMemo, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { adsFieldAlias } from '../validators';

export const ErrorContext = React.createContext([]);

export function Error(props) {
  const {
    filter,
    property,
    index,
  } = props;

  const { errors, onFirstErrorHandler } = useContext(ErrorContext);
  const alertRef = useRef(null);

  const filteredErrors = useMemo(() => {
    if (_.isFunction(filter)) {
      return _.filter(errors, error => filter(error));
    } else if (!_.isEmpty(property)) {
      return _.filter(errors, error => (error.Property === property ||
        error.Property === adsFieldAlias[property]) &&
        (index === null || index === error.Index));
    }
    return errors;
  }, [errors, filter, index, property]);

  useEffect(() => {
    if (filteredErrors && filteredErrors.length > 0 && errors[0].Property === filteredErrors[0].Property) {
      onFirstErrorHandler(alertRef.current);
    }
  }, [errors, filteredErrors, onFirstErrorHandler]);

  return filteredErrors && filteredErrors.length > 0 ? (
    <div
      role="alert"
      className="rsa-errors"
      ref={alertRef}
    >
      { _.map(filteredErrors, error => (
        <div key={error.Message} className="error">
          {error.Message || error.Code}
        </div>
      ))}
    </div>
  ) : null;
}

Error.propTypes = {
  filter: PropTypes.func,

  property: PropTypes.string,

  index: PropTypes.number,
};

Error.defaultProps = {
  filter: null,
  property: null,
  index: null,
};
